import { create } from "zustand"

export const useGeneralStore = create((set) => ({
  footerData: {},
  navbarData: [],
  listInvestors: [],
  listGovernance: [],
  setFooterData: (payload) => set({ footerData: payload }),
  setNavbarData: (payload) => set({ navbarData: payload }),
  setListInvestors: (payload) => set({ listInvestors: payload }),
  setListGovernance: (payload) => set({ listGovernance: payload }),
}))
